// #94 AgreeRow (debrief D-7): a check row only its named person can tick (*HM agreement* · *Recruiter agreement*,
// both required for the additional-interview exception). The row is a CheckRow (an <li>: put it in a Checklist) whose
// glyph follows the tick; the person slot holds the person and the trailing control slot the tick. For anyone else the tick is blocked and its
// reason is that person's name (DS #94). `mode="view"` shows the glyph and the person only.

import { useState } from "react";
import { cx } from "../lib/cx";
import { useSvgId } from "../lib/useSvgId";
import { CheckRow } from "../core/Checklist";
import { Avatar } from "../core/Person";
import { CheckTick } from "./Tick";
import type { Hs } from "../lib/hs";

export interface AgreeRowProps {
  /** His words for the agreement (HM agreement · Recruiter agreement). */
  label: string;
  /** The one person who may tick it. */
  person: { name: string; hueKey?: string | undefined };
  /** The viewer is that person. */
  mine: boolean;
  checked?: boolean | undefined;
  defaultChecked?: boolean | undefined;
  onChange?: ((checked: boolean) => void) | undefined;
  can?: boolean | undefined;
  mode?: "edit" | "view" | undefined;
  hs?: Hs | undefined;
  className?: string | undefined;
}

export function AgreeRow({ label, person, mine, checked, defaultChecked = false, onChange, can, mode, hs, className }: AgreeRowProps) {
  const id = useSvgId();
  const [own, setOwn] = useState(defaultChecked);
  if (can === false) return null;
  const on = checked ?? own;
  const flip = (next: boolean) => {
    if (checked === undefined) setOwn(next);
    onChange?.(next);
  };
  const wordsId = `${id}-w`;
  return (
    <CheckRow
      status={on ? "ok" : "todo"}
      className={cx("mc-agree", className)}
      sub={person.name}
      person={<Avatar name={person.name} hueKey={person.hueKey} size={24} decorative />}
      control={mode === "view" ? undefined : (
        <CheckTick checked={on} onChange={flip} labelledBy={wordsId} blocked={mine ? undefined : { reason: person.name }} hs={hs} />
      )}
    >
      <span id={wordsId}>{label}</span>
    </CheckRow>
  );
}
